import { getMessages } from '../../../../../../store/constants';

export const COLOR_ROW_PICKER_BUTTON_CANCEL = getMessages().getText('common.cancel');
export const COLOR_ROW_PICKER_BUTTON_SAVE = getMessages().getText('common.save');

export const COLOR_ROW_PICKER_DEFAULT_COLOR = '#673ab7';
